const BASE_URL = (location.hostname === "localhost") ? "http://localhost:3000" : "https://vue-personal-portfolio-production.up.railway.app"
export default BASE_URL
